import Graphic from '@arcgis/core/Graphic';
import { DEFAULT_MAP_SOURCE } from '@env';

import { FsMapComponentType } from './map-component';

export enum FsMarkerSymbolType {
  PIN,
  SQUARE,
  CIRCLE,
  CIRCLE_PIN,
  IMAGE,
}

export interface FsFontProperties {
  decoration?: 'underline' | 'line-through' | 'none';
  family?: string;
  size?: number | string;
  style?: 'normal' | 'italic' | 'oblique';
  weight?: 'normal' | 'bold' | 'bolder' | 'lighter';
}

export interface FsMarkerTextSymbolOptions {
  isLabel?: boolean;
  font?: FsFontProperties;
  text?: string;
  verticalAlignment?: 'baseline' | 'top' | 'middle' | 'bottom';
  xoffset?: number | string;
  yoffset?: number | string;
}

export type FsMarker = FsMapComponentType<
  typeof DEFAULT_MAP_SOURCE,
  google.maps.marker.AdvancedMarkerElement,
  Graphic[]
>;
